<div class="card">
    <div class="card-body">
        <div class="col-12 text-center">
            <button class="btn btn-primary btn-sm no-print" *ngIf="mylist.length>0" (click)="print_p();">
                <mat-icon>print</mat-icon> </button>
        </div>
        <div class="row">
            <div class="col-3 text-center border border-dark" *ngFor="let item of mylist">
                <p>
                    <b>[{{item.fmcode_.trim()}}] {{item.fmname.trim()}}</b> <br>
                    <ngx-barcode [bc-value]="item.truck_q" [bc-height]="30" [bc-font-size]='15'
                        [bc-display-value]="true"></ngx-barcode>
                    [{{item.landno}}] กลุ่ม {{item.groupcode}} <br>
                    [{{item.canename}}] {{item.landvalue|number}} ไร่ เที่ยว {{item.qcard|number}} ส่งลาน
                </p>
            </div>
        </div>
        <div class="col-12 text-center">
            <b>[{{dateLOC}}]</b>
            <hr />
        </div>
    </div>
</div>